"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tw = tw;
/**
 * This is an identity function, it's only use is to enable
 * tailwind linting and autocomplete for simple static styles like:
 *
 * ```typescript
 * export const formField = tw(`relative w-fit`);
 * ```
 *
 * See .eslintrc.js > settings.callees
 */
function tw(arg) {
  return arg;
}
